<div class="parties" [formGroup]="group">
  <div class="parties__action-buttons">
    <app-party-selector
      (selectedParty)="onPartySelect($event)"
      [suggestedParty]="mainParty()"
      [disabled]="!mainParty()"></app-party-selector>
    <mat-checkbox [formControlName]="checkboxControlName">{{ checkboxLabel }}</mat-checkbox>
  </div>
  <table class="parties__table" matSort (matSortChange)="onSort($event)">
    <thead>
      <tr>
        <th>
          <div class="parties__table--header">
            <app-party-column-filter (filterApplied)="onFilter($event, 'name')"></app-party-column-filter>
            <div mat-sort-header="name">Party Name</div>
          </div>
        </th>
        <th>
          <div class="parties__table--header">
            <app-party-column-filter (filterApplied)="onFilter($event, 'number')"></app-party-column-filter>
            <div mat-sort-header="number">Party Number</div>
          </div>
        </th>
        <th align="right">Actions</th>
      </tr>
    </thead>
    <tbody>
      @for (party of partyControls(); track party) {
        <tr>
          <td>{{ party.get('name')?.value }}</td>
          <td>{{ party.get('number')?.value }}</td>
          <td align="right">
            <button matIconButton (click)="removeParty(party)">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </tr>
      } @empty {
        <tr>
          <td colspan="3" class="no-parties">No parties assigned yet</td>
        </tr>
      }
    </tbody>
  </table>
</div>
